import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Field, StyledRow } from './field';

const inputStyle = {
  textAlign: 'left' as const,
};

export const LoadSettingsFields: React.FC<{
  outbound: boolean;
}> = ({ outbound }) => {
  const { errors, register } = useFormContext<{
    anyCartonExceedsFiftyPounds: boolean;
    authorizedToShipShort: boolean;
    cartonsNeedToBeStoredUpright: boolean;
    loadDimensionsRequired: boolean;
    loadWeightRequired: boolean;
    trailerSealRequired: boolean;
  }>();

  return (
    <>
      {outbound ? (
        <StyledRow className="row">
          <div className="col-md-4">
            <Field
              error={errors.authorizedToShipShort}
              id="authorizedToShipShort"
              label="Authorized to Ship Short?"
              required={true}
            >
              <input
                id="authorizedToShipShort"
                type="checkbox"
                className="form-control"
                name="authorizedToShipShort"
                ref={register}
                style={inputStyle}
              />
            </Field>
          </div>
          <div className="col-md-4">
            <Field
              error={errors.loadDimensionsRequired}
              id="loadDimensionsRequired"
              label="Load Dimensions Required?"
              required={true}
            >
              <input
                id="loadDimensionsRequired"
                type="checkbox"
                className="form-control"
                name="loadDimensionsRequired"
                ref={register}
                style={inputStyle}
              />
            </Field>
          </div>
          <div className="col-md-4">
            <Field
              error={errors.loadWeightRequired}
              id="loadWeightRequired"
              label="Load Weight Required?"
              required={true}
            >
              <input
                id="loadWeightRequired"
                type="checkbox"
                className="form-control"
                name="loadWeightRequired"
                ref={register}
                style={inputStyle}
              />
            </Field>
          </div>
          <div className="col-md-4">
            <Field
              error={errors.trailerSealRequired}
              id="trailer_seal_required"
              label="Trailer Seal Required?"
              required={true}
            >
              <input
                id="trailer_seal_required"
                type="checkbox"
                className="form-control"
                name="trailerSealRequired"
                ref={register}
                style={inputStyle}
              />
            </Field>
          </div>
        </StyledRow>
      ) : (
        <StyledRow className="row">
          <div className="col-md-4">
            <Field
              error={errors.anyCartonExceedsFiftyPounds}
              id="anyCartonExceedsFiftyPounds"
              label="Any Carton Exceeds 50 Pounds?"
              required={true}
            >
              <input
                id="anyCartonExceedsFiftyPounds"
                type="checkbox"
                className="form-control"
                name="anyCartonExceedsFiftyPounds"
                ref={register}
                style={inputStyle}
              />
            </Field>
          </div>
          <div className="col-md-4">
            <Field
              error={errors.cartonsNeedToBeStoredUpright}
              id="cartonsNeedToBeStoredUpright"
              label="Cartons Need to be Stored Upright?"
              required={true}
            >
              <input
                id="cartonsNeedToBeStoredUpright"
                type="checkbox"
                className="form-control"
                name="cartonsNeedToBeStoredUpright"
                ref={register}
                style={inputStyle}
              />
            </Field>
          </div>
        </StyledRow>
      )}
    </>
  );
};
